/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from "vue-property-decorator";
import { UserModule } from '@/store/modules/user'

import {
    getCustomerNameListByFinanceBackMoneyMainPart,
    getFinanceOrderByCustomerIdOrMarketCooperationId,
    setFinanceBackMoney,
    getFinanceBackMoneyInfoById,
    getFinanceBackMoneyById,
    setFinanceBackMoneyById,
    getFinanceBackMoneyDetailTemplate,
    importFinanceBackMoneyDetail,
    getFinanceBackMoneyDetailByFinanceInvoiceId
} from '@/api/financial-center'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import { getDraftById, setDraftById } from '@/api/draft'
import { delNullProperty } from "@/utils";
import * as math from 'mathjs'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import {makeUploadSignature} from "@/utils/uploadMd5";

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class NewBackMoneyMechanism extends Vue {
    parnterConfirmList = {
        marketCooperationCreatedAt: '',
        marketCooperationDirectorUserId: '',
        marketCooperationId: NaN,
        marketCooperationName: '',
        marketCooperationTypes: '',
        parentMarketCooperationName: ''
    }
    parnterConfirmDisable = false
    tableRandom = Math.random()
    tableKey = Math.random()
    customerNameOrMarketCooperationName = ''
    parnterDialog = false
    parnterDialogInputValue = ''
    parnterDialogTaleData = []
    parnterDialogTotal = 0
    parnterDialogFilterTotal: number = null
    parnterDialogPage = 1
    parnterDialogTableLoading = false
    parnterDialogSelect = {
        marketCooperationCreatedAt: '',
        marketCooperationDirectorUserId: '',
        marketCooperationId: NaN,
        marketCooperationName: '',
        marketCooperationTypes: '',
        parentMarketCooperationName: ''
    }

    orderDialog = false
    orderDialogInputValue = ''
    orderDialogTaleData = []
    orderDialogSelectTable = []
    orderDialogTotal = null
    orderAllTotal = null
    orderDialogFilterTotal: number = null
    orderDialogPage = 1
    limit = 20
    orderDialogTableLoading = false
    orderList = []
    orderDialogSelect: any = []
    formData = {
        backMoneyContent: '合作伙伴',
        parnterName: '',
        // backMoneyAccount: '北京集思互联教育科技有限公司',
        backMoneyAccount: '',
        date: new Date(),
        directorUserId: UserModule.userId || '',
        deparment: '',
        deparmentId: NaN,
        remark: '',  //备注
        payAccount: '' ,//付款账户
        payMethod: '' ,//付款方式
    }
    tableData = []
    newTable = []
    fileList = []
    backMoneyAccountOptions = [
        '苏州',
        '北京集思互联教育科技有限公司',
        '广州',
        '上海恒艾教育科技有限公司',
        '北京昌意科技有限公司',
        '天津集思互动教育咨询有限公司',
        '青岛集思互动教育咨询有限公司',
        '蒸汽松鼠（北京）科技有限公司'
    ]

    disabledButton = false
    saveDraftDialogShow = false
    errorDialogShow = false
    isDraft = '0'

    orderId: number = null // 如果是从订单列表页点击进来的就会有值，订单id
    backMoneyId: number = null // 编辑的时候会有值，回款id
    editUserName = '' // 编辑的时候使用
    editCreatedAt: Date = null // 编辑的时候用来返显
    draftId: number = null // 从草稿跳转来的
    backMoneyStatus = ''
    isUpdatedData= '0'
    isShow = ''
    previewVisible = false
    previewPath = ''
    previewName = ''

    formRule = {
        parnterName: [{ required: true, message: '请选择合作伙伴名称', trigger: 'change' }],
        payMethod: [{ required: true, message: '请选择付款方式', trigger: 'change' }],
        date: [{ required: true, message: '请选择回款日期', trigger: 'change' }],
    }
    // financeBackMoney = {
    //     financeBackMoneyDetailList:[]
    // }
    oldOrderDialogSelectTable: any = [] //取消选中数据
    oldRowOrderDialogSelectTable: any = [] //取消行选中数据
    detailOrderArr: any = []
    setPriceDialogShow = false //设置金额
    setPrice = ''
    file = []
    fileData = null
    readyOption = true
    menuBtn = menuBtn
    timer = null
    // isReadonly = false
    timernew = null
    reasonDialogVisible = false
    needBackMoneyReason = ''
    backMoneyWayOptions = [
        {label: '全额回款', value: '0'},
        {label: '扣佣金后回款', value: '1'},
        {label: '分期回款', value: '2'},
    ]
    setBackMoneyWay = '' // 一键设置回款方式
    setBackMoneyWayDialogShow = false
    directorUserName = ''
    loading = false
    uploadData = {
        bucket: 'crm',
        signature: ''
    }


    get userName() {
        return UserModule.userName
    }

    get departmentName() {
        return UserModule.department
    }

    get directorUserId() {
        return UserModule.userId
    }

    get orderAllPrice() {
        let num = 0
        this.tableData.forEach(item => num += Number(item.price))
        return num
    }
    // 回款详情总条数
    get detail_all_num() {
        return this.tableData.length
    }

    get shouldBackAmount() {

        let num = 0
        this.tableData.forEach(item => {

                num += Number(item.needBackMoney)
            }
        )
        return num
    }

    get surplusBackMoney() {
        let num = 0
        // let lastMoney = 0
        // this.financeBackMoney.financeBackMoneyDetailList.forEach(item => {
        //     lastMoney += Number(item.thisTimePrice)
        // })
        // num = num - lastMoney
        this.tableData.forEach(item => {
            num = math.number(math.add(math.bignumber(num), math.bignumber(Number(item.needBackMoney))))
        })
        return  math.number(math.subtract(math.bignumber(num ),math.bignumber(this.thisBackMoney)))
    }
    // 待回款金额
    get needBackMoney() {
        let num = 0

        this.tableData.forEach(item => {
            if (!item.newNeedBackMoney) {
                item.newNeedBackMoney = 0
            }
            if (!item.needBackMoney) {
                item.needBackMoney = 0
            }
            num = math.number(math.add(math.bignumber(num) , math.bignumber(Number(item.newNeedBackMoney))));
        })
        return num
    }

    get thisBackMoney() {
        let num = 0
        this.tableData.forEach(item => {
            if(Number(item.thisBackMoney)) {
                num = math.number(math.add(math.bignumber(num), math.bignumber(Number(item.thisBackMoney))))
            }
        })
        return num
    }

    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }

    created() {
        if(this.$route.query.isUpdatedData) this.isUpdatedData = this.$route.query.isUpdatedData as string
        if(this.$route.query.isShow) this.isShow = this.$route.query.isShow as string
        if(this.$route.query.orderId) {
            this.orderId = Number(this.$route.query.orderId)
            this.getFinanceBackMoneyInfoById()
        }

        if(this.$route.query.backMoneyId) {
            this.backMoneyId = Number(this.$route.query.backMoneyId)
            this.getFinanceBackMoneyById()
        }

        if(this.$route.query.draftId){
            this.draftId = Number(this.$route.query.draftId)
            this.getDraftById()
        }

        if (this.$route.query.makeInvoiceId) {
            //     从开票过来的回款
            this.getFinanceBackMoneyByMakeInvoiceId()
        }

        if(this.$route.query.status) this.backMoneyStatus = this.$route.query.status as string
    }

    beforeUpload (file) {
        // 1. 为当前文件实时生成专属 signature，并同步更新全局 uploadData
        const currentSignature = makeUploadSignature('crm', file.name);
        // this.uploadData.signature = currentSignature; // 同步更新，立即生效
        this.$set(this.uploadData, 'signature', currentSignature);
    }

    async getFinanceBackMoneyByMakeInvoiceId() {
        await getFinanceBackMoneyDetailByFinanceInvoiceId({financeInvoiceId: String(this.$route.query.makeInvoiceId)}).then((res: any) => {
            const data: any = res.financeBackMoneyDetail
            this.formData.parnterName = data.marketCooperationName
            this.parnterDialogSelect.marketCooperationTypes = data.marketCooperationTypes
            this.parnterDialogSelect.marketCooperationId = data.marketCooperationId
            this.formData.backMoneyAccount = data.financeOrderList[0].companyName
            this.tableData = data.financeOrderList.map(item => {
                    return ({
                        ...item,
                        thisBackMoney: item.thisTimePrice,
                        thisBackMoneyWay: String(item.types),
                        newNeedBackMoney: math.number(math.subtract(math.bignumber(Number(item.needBackMoney)),math.bignumber(Number(item.thisTimePrice)))),
                        oldThisBackMoney: 0,
                    })
                }
            )
        })
    }

    changeWay(row, val) {
        if (val === '0') {
            row.thisBackMoney = row.price // 如果回款方式为全额回款，则本次回款金额默认为订单金额
        }
        this.tableData.forEach(item => {
            if(item.id === row.id) {
                item.newNeedBackMoney = math.number(math.subtract(math.bignumber(Number(item.needBackMoney)),math.bignumber(Number(row.thisBackMoney))))
            }
        })
    }

    handleSetPrice(val){
        val = this.handleOninput(val,'2')
        this.setPrice = this.handleOninput(val,'2')
    }
    handleOninput(num,limit){
        let str = num
        const len1 = str.substr(0, 1)
        const len2 = str.substr(1, 1)
        //如果第一位是0，第二位不是点，就用数字把点替换掉
        if (str.length > 1 && len1 == 0 && len2 != ".") {
            str = str.substr(1, 1)
        }
        //第一位不能是.
        if (len1 == ".") {
            str = ""
        }
        //限制只能输入一个小数点
        if (str.indexOf(".") != -1) {
            const str_ = str.substr(str.indexOf(".") + 1)
            if (str_.indexOf(".") != -1) {
                str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1)
            }
        }
        //正则替换
        str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
        if (limit / 1 === 1) {
            str = str.replace(/^\D*([0-9]\d*\.?\d{0,1})?.*$/,'$1') // 小数点后只能输 1 位
        } else {
            str = str.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1') // 小数点后只能输 2 位
        }
        return str
    }
    // 回款明细导出
    exportExcelData(res) {
        require.ensure([], () => {
            const { export_json_to_excel } = require('../../../../vender/Export2Excel.js')
            const tHeader = ['客户名称','订单编号','项目名称','开课时间','订单金额','订单已回款金额','订单待回款金额','本次回款金额']
            const filterVal =  ['customerName','code','souCourseName','souCourseSchoolBegin','price','backMoney','newNeedBackMoney','thisBackMoney']
            const list = this.tableData
            const data = this.formatJson(filterVal, list)
            export_json_to_excel(tHeader, data, '回款明细')
        })
    }
    formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
    }

    async getFinanceBackMoneyById() {
        const data: any = await getFinanceBackMoneyById({ id: this.backMoneyId, isUpdatedData: this.isUpdatedData })
        const {financeBackMoney} = data
        // this.financeBackMoney = financeBackMoney
        this.editUserName = financeBackMoney.createdUserRealName
        this.editCreatedAt = new Date(financeBackMoney.createdAt)

        this.formData.backMoneyAccount = financeBackMoney.account
        this.formData.date = new Date(financeBackMoney.backMoneyAt)
        this.formData.directorUserId = financeBackMoney.directorUserId
        this.directorUserName = financeBackMoney.directorUserRealName
        this.formData.parnterName = financeBackMoney.marketCooperationName
        this.formData.deparment = financeBackMoney.directorDepartmentlName
        this.formData.deparmentId = financeBackMoney.directorDepartmentId
        this.formData.remark = financeBackMoney.remark
        this.formData.payAccount = financeBackMoney.payAccount
        this.formData.payMethod = financeBackMoney.payMethod == '第三方' ? '0' : financeBackMoney.payMethod == '银行' ? '1' : ''

        this.parnterDialogSelect.marketCooperationId = financeBackMoney.marketCooperationId
        this.parnterDialogSelect.marketCooperationName = financeBackMoney.marketCooperationName
        this.parnterDialogSelect.marketCooperationTypes = financeBackMoney.marketCooperationTypes

        this.tableData = financeBackMoney.financeBackMoneyDetailList.map(item => {
            return {
                customerName: item.customerName,
                code: item.code,
                souCourseName: item.souCourseName,
                souCourseSchoolBegin: item.souCourseSchoolBegin,
                price: item.price,
                backMoney: item.backMoney,
                needBackMoney: this.isShow === '1' ? Number(item.needBackMoney) + Number(item.thisTimePrice):Number(item.needBackMoney),
                // newNeedBackMoney: item.needBackMoney, // 旧的写法
                newNeedBackMoney: this.isShow === '1' ? item.needBackMoney : (item.thisTimePrice ? math.number(math.subtract(math.bignumber(Number(item.needBackMoney)), math.bignumber(Number(item.thisTimePrice)))) : item.needBackMoney),
                thisBackMoney: item.thisTimePrice,
                oldThisBackMoney: this.isShow === '1' ? item.thisTimePrice : 0, // 如果当前回款审批通过，在验证本次回款金额是否正确的时候就需要将本次回款的金额一起验证
                id: item.financeOrderId,
                companyName: item.companyName, // 所属公司
                thisBackMoneyWay: item.types == '全额回款' ? '0' : item.types == '扣佣金后回款' ? '1' : item.types == '分期回款' ? '2' : '', // 回款方式
            }
        })
        this.newTable = this.tableData
        // this.orderDialogSelectTable = financeBackMoney.financeBackMoneyDetailList

        this.fileList = financeBackMoney.financeBackMoneyProofList
    }

    async getFinanceBackMoneyInfoById() {
        this.loading = true
        await getFinanceBackMoneyInfoById({mainPart: '1', id: this.orderId}).then((data: any) => {
            const {financeBackMoneyInfo} = data
            this.formData.parnterName = financeBackMoneyInfo.marketCooperationName
            this.parnterDialogSelect.marketCooperationName = financeBackMoneyInfo.customerName
            this.parnterDialogSelect.marketCooperationId = financeBackMoneyInfo.marketCooperationId
            this.parnterDialogSelect.marketCooperationTypes = financeBackMoneyInfo.marketCooperationTypes

            this.tableData.push({
                customerName: financeBackMoneyInfo.customerName,
                code: financeBackMoneyInfo.code,
                souCourseName: financeBackMoneyInfo.souCourseName,
                souCourseSchoolBegin: financeBackMoneyInfo.souCourseSchoolBegin,
                price: financeBackMoneyInfo.price,
                backMoney: financeBackMoneyInfo.backMoney,
                needBackMoney: financeBackMoneyInfo.needBackMoney,
                newNeedBackMoney: financeBackMoneyInfo.needBackMoney,
                thisBackMoney: 0,
                oldThisBackMoney: 0,
                id: this.orderId,
                thisBackMoneyWay: '', // 回款方式
            })
            this.formData.backMoneyAccount = financeBackMoneyInfo.companyName
            this.formData.payMethod = financeBackMoneyInfo.payMethod == '第三方' ? '0' : financeBackMoneyInfo.payMethod == '银行' ? '1' : ''
            this.loading = false
        }).catch(err => {
            this.loading = false
        })
    }

    // async directorUserIdChange(val) {
    //     const selectedItem = this.userList.find(item => item.id === val);
    //     this.formData.deparment = selectedItem.departmentName
    // }

    async getCustomerNameListByFinanceBackMoneyMainPart() {
        this.parnterDialogTableLoading = true

        const obj = {
            mainPart: '1',
            page: this.parnterDialogPage,
            customerNameOrMarketCooperationName:this.customerNameOrMarketCooperationName,
            limit: this.limit
        }
        const data: any = await getCustomerNameListByFinanceBackMoneyMainPart(delNullProperty(obj))
        this.parnterDialogTaleData = data.customerOrMarketCooperationList
        this.parnterDialogTotal = data.allNum
        this.parnterDialogTableLoading = false

        this.tableRandom = Math.random()
    }

    async getFinanceOrderByCustomerIdOrMarketCooperationId() {
        this.orderDialogTableLoading = true

        // 发请求拿到数据并暂存全部数据
        const obj = {
            mainPart: '1',
            marketCooperationId: this.parnterDialogSelect.marketCooperationId,
            page: this.orderDialogPage,
            limit: this.limit,
            customerName: this.orderDialogInputValue
        }
        const data: any = await getFinanceOrderByCustomerIdOrMarketCooperationId(delNullProperty(obj))
        this.orderDialogTaleData = data.financeOrderList
        this.orderDialogTotal = data.allNum
        this.orderDialogTableLoading = false

    }
    async getAllTotal(){
        const obj = {
            mainPart: '1',
            marketCooperationId: this.parnterDialogSelect.marketCooperationId,
            page: this.orderDialogPage,
            limit: this.orderAllTotal
        }
        const data: any = await getFinanceOrderByCustomerIdOrMarketCooperationId(obj)
        this.orderList = data.financeOrderList
        this.orderDialogTableLoading = false

        this.tableKey = Math.random()
        this.getList()
    }
    getList() {
        //  es6过滤得到满足搜索条件的展示数据list
        const list = this.orderList.filter((item, index) =>
            item.customerName.includes(this.orderDialogInputValue)
        )
        //过滤分页
        this.orderDialogTaleData = list.filter((item, index) =>
            index < this.orderDialogPage * this.limit && index >= this.limit * (this.orderDialogPage - 1)
        );
        //分页的总数据
        this.orderDialogTotal = list.length
        this.setCheckedRows() //回显已勾选的数据
    }
    // 4、回显已勾选的数据
    setCheckedRows(){
        // this.orderDialogSelect = this.orderDialogSelectTable.map(item => item.financeOrderId?item.financeOrderId:item.id);
        // this.orderDialogSelect.push(arr)
        this.orderDialogSelect = this.tableData.map(item => item.id);
        const selectItem = []
        this.$nextTick(() => {
            const { orderDialogSelect, orderList } = this
            orderDialogSelect.forEach(key => {
                orderList.forEach(row => {
                    if (row.id == key) {
                        setTimeout(() => {
                            (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row, true)
                        }, 300);
                    }
                })
            })
        })
    }
    // 解决Table 切换页面 原先选择状态消失
    getRowKeys(row) {
        // id 是后台传递的每行信息唯一标识
        return row.id
    }
    handleSizeChange(val) {
        this.limit = val
        this.getFinanceOrderByCustomerIdOrMarketCooperationId()
    }

    handleCurrentChange(val) {
        this.orderDialogPage = val
        this.getFinanceOrderByCustomerIdOrMarketCooperationId()
    }



    // async getFinanceOrderByCustomerIdOrMarketCooperationId() {
    //     this.orderDialogTableLoading = true
    //     let limit = 20
    //     if(Number(this.orderDialogTotal) >= 20){
    //         limit = this.orderDialogTotal ? this.orderDialogTotal : 20
    //     }
    //     const obj = {
    //         mainPart: '1',
    //         marketCooperationId: this.parnterDialogSelect.marketCooperationId,
    //         page: 1,
    //         limit: limit
    //     }
    //     const data: any = await getFinanceOrderByCustomerIdOrMarketCooperationId(obj)
    //     let newList = data.financeOrderList.map(item => ({ ...item,  selectDisabled: true, newNeedBackMoney: item.needBackMoney }))
    //     newList = newList.filter(item => item.customerName.includes(this.orderDialogInputValue))
    //     this.orderDialogTaleData = newList.map((item, index: number) => {
    //         if(index >= (this.orderDialogPage * 20) - 20 && index < this.orderDialogPage * 20) return item
    //     }).filter(item => item)
    //     this.orderDialogFilterTotal = this.orderDialogInputValue ? newList.length : null
    //     this.orderDialogTotal = data.allNum
    //     this.orderDialogTableLoading = false
    //     this.$nextTick(() => {
    //         const dom = this.$refs.orderDialogTable as HTMLFormElement
    //         if(this.tableData.length > 0) {
    //             dom.clearSelection()
    //             const orderIds = this.tableData.map(item => item.id)
    //             const newArr = this.orderDialogTaleData.filter(item => orderIds.includes(item.id))
    //             newArr.forEach(item => {
    //                 dom.toggleRowSelection(item, true)
    //                 // item.selectDisabled = false * 2022.1.04 放弃禁用，改为回显 *
    //             })
    //         } else {
    //             dom.clearSelection()
    //         }
    //     })
    // }

    //- 一键设置回款方式
    clickSetBackMoneyWay(){
        if(this.tableData.length == 0){
            this.$message.error('请添加订单')
            return
        }
        this.setBackMoneyWay = ''
        this.setBackMoneyWayDialogShow = true
    }

    handleSetBackMoneyWayDialogSave() {
        if (this.setBackMoneyWay == '' || this.setBackMoneyWay == undefined || this.setBackMoneyWay == null) {
            this.$message.error('请填写本次回款方式')
            return
        }
        this.tableData = this.tableData.map(item => ({
            ...item,
            thisBackMoneyWay: this.setBackMoneyWay,
            thisBackMoney: this.setBackMoneyWay === '0'? item.price : item.thisBackMoney, // 一件设置回款 如果回款方式为全额 则本次回款金额为订单金额，否则为默认的
            newNeedBackMoney: math.number(math.subtract(math.bignumber(Number(item.needBackMoney)),math.bignumber(Number( this.setBackMoneyWay === '0'? item.price : item.thisBackMoney))))
        }))
        this.setBackMoneyWayDialogShow = false
    }

    async clickSubmintButton() {
        // if(!this.formData.parnterName) { this.$message.error('请选择学生'); return }
        // if(!this.formData.backMoneyAccount) { this.$message.error('请选择收款账户'); return }
        let flag = true;
        (this.$refs.formRef as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false;
            }
        })
        if (this.tableData.length === 0) {
            await this.$message.error('请添加订单');
            return;
        }

        if (this.fileList.length === 0) {
            await this.$message.error('请上传回款凭证');
            return;
        }
        if (!this.formData.payMethod) {
            await this.$message.error('请选择付款方式');
            return;
        }

        const obj = {
            mainPart: '1',
            marketCooperationId: this.parnterDialogSelect.marketCooperationId,
            account: this.formData.backMoneyAccount,
            backMoneyAt: formatDate('yyyy-MM-dd', new Date(this.formData.date)),
            financeBackMoneyDetailList: [],
            financeBackMoneyProofList: this.fileList,
            directorUserId: this.formData.directorUserId,
            isDraft: this.isDraft,
            remark: this.formData.remark, //备注
            payMethod: this.formData.payMethod,
            content: (this.tableData.some(item => Number(item.thisBackMoney) < (Number(item.needBackMoney))) && this.isDraft !== '1') ? this.needBackMoneyReason : ''
        }

        obj.financeBackMoneyDetailList = this.tableData.map(item => {
                return ({
                    financeOrderId: item.id,
                    thisTimePrice: String(item.thisBackMoney),
                    types: String(item.thisBackMoneyWay)
                })
            }
        )

        /*
       * 判断数组的每一项是否都不为0*/
        const isAllZero = obj.financeBackMoneyDetailList.every(item => (item.thisTimePrice !== 0 && item.thisTimePrice !== ''));
        if (!isAllZero) {
            this.$message.error('有未填写本次回款金额的订单，请去填写')
            return;
        }
        /*判断this.tableData的每一项的thisBackMoneyWay都不为空*/
        if (!(obj.financeBackMoneyDetailList.every(item => (item.types !== '' && item.types !== 'undefined')))) {
            this.$message.error('有未填写本次回款方式的订单，请去填写')
            return
        }

        if (this.isDraft !== '1' && !this.needBackMoneyReason) {
            /*判断tableData下每一项中是否有本次回款金额小于待回款金额的项*/
            if (this.tableData.some(item => Number(item.thisBackMoney) < (Number(item.needBackMoney)))) {
                this.reasonDialogVisible = true
                flag = false
            }
        }
        if (flag) {
            this.disabledButton = true
        } else {
            return;
        }

        this.loading = true
        setFinanceBackMoney(delNullProperty(obj)).then(() => {
            this.$message.success(`${this.isDraft === '0' ? '新建成功' : '已保存到草稿箱'}，页面即将关闭`)
            this.loading = false
            setTimeout(() => {
                this.closePage()
            }, 1500)

        }).catch((err: Error) => {
            if (err) {
                this.disabledButton = false
                this.needBackMoneyReason = ''
            }
            if (err.message === '审批流报错') {
                this.errorDialogShow = true
            }
            this.loading = false
        })

    }

    async getDraftById() {
        this.loading = true
        await getDraftById(this.draftId).then((data: any) => {
            const {result} = data

            this.editUserName = result.createdUserRealName
            this.editCreatedAt = new Date(result.createdAt)

            this.formData.backMoneyAccount = result.account
            this.formData.date = new Date(result.backMoneyAt)
            this.formData.directorUserId = result.directorUserId
            this.directorUserName = result.directorUserRealName
            this.formData.parnterName = result.marketCooperationName
            this.formData.deparment = result.directorDepartmentlName
            this.formData.deparmentId = result.directorDepartmentId
            this.formData.remark = result.remark
            this.formData.payMethod = result.payMethod == '第三方' ? '0' : result.payMethod == '银行' ? '1' : ''

            this.parnterDialogSelect.marketCooperationId = result.marketCooperationId
            this.parnterDialogSelect.marketCooperationName = result.marketCooperationName
            this.parnterDialogSelect.marketCooperationTypes = result.marketCooperationTypes

            this.tableData = result.financeBackMoneyDetailList.map(item => {
                return {
                    customerName: item.customerName,
                    code: item.code,
                    souCourseName: item.souCourseName,
                    souCourseSchoolBegin: item.souCourseSchoolBegin,
                    price: item.price,
                    backMoney: item.backMoney,
                    needBackMoney: Number(item.needBackMoney),
                    newNeedBackMoney: math.number(math.subtract(math.bignumber(Number(item.needBackMoney)), math.bignumber(Number(item.thisTimePrice)))),
                    thisBackMoney: item.thisTimePrice,
                    oldThisBackMoney: 0,
                    id: item.financeOrderId,
                    thisBackMoneyWay: item.types == '全额回款' ? '0' : item.types == '扣佣金后回款' ? '1' : item.types == '分期回款' ? '2' : '', // 回款方式
                    // thisBackMoneyWay: item.types, // 回款方式
                }
            })

            this.fileList = result.financeBackMoneyProofList
            this.loading = false
        }).catch(err => {
            this.loading = false
        })
    }

    clickEditSubmitButton() {
        if (!this.formData.payMethod) {
            this.$message.error('请选择付款方式');
            return;
        }
        let flag = true;
        (this.$refs.formRef as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false;
            }
        })
        const obj = {
            id: this.backMoneyId,
            account: this.formData.backMoneyAccount,
            backMoneyAt: formatDate('yyyy-MM-dd', new Date(this.formData.date)),
            financeBackMoneyDetailList: [],
            financeBackMoneyProofList: this.fileList,
            directorUserId: this.formData.directorUserId,
            remark: this.formData.remark,
            payMethod: this.formData.payMethod,
            content: this.tableData.some(item => Number(item.thisBackMoney) < (Number(item.needBackMoney)))  ? this.needBackMoneyReason : ''
        }


        obj.financeBackMoneyDetailList = this.tableData.map(item => {
                return ({
                    financeOrderId: item.id,
                    thisTimePrice: String(item.thisBackMoney),
                    types: String(item.thisBackMoneyWay)
                })
            }
        );


        /*
       * 判断数组的每一项是否都不为0*/
        const isAllZero = obj.financeBackMoneyDetailList.every(item => (item.thisTimePrice !== 0 && item.thisTimePrice !== ''));
        if (!isAllZero) {
            this.$message.error('有未填写本次回款金额的订单，请去填写')
            return;
        }
        /*判断this.tableData的每一项的thisBackMoneyWay都不为空*/
        if (!(obj.financeBackMoneyDetailList.every(item => (item.types !== '' && item.types !== 'undefined')))) {
            this.$message.error('有未填写本次回款方式的订单，请去填写')
            return
        }
        if (!this.needBackMoneyReason) {
            /*判断每一个订单的本次回款金额是否等于待回款金额*/
            if (this.tableData.some(item => Number(item.thisBackMoney) < (Number(item.needBackMoney)))) {
                this.reasonDialogVisible = true
                flag = false
            }
        }

        if (flag) {
            this.disabledButton = true
        } else {
            return;
        }
        this.loading = true
        setFinanceBackMoneyById(delNullProperty(obj)).then(res => {
            this.$message.success('提交成功，页面即将关闭')
            this.loading = false
            setTimeout(() => {
                this.closePage()
            }, 1500)
        }).catch(err => {
            if (err.message === '审批流报错') {
                this.errorDialogShow = true
            }
            this.disabledButton = false
            this.loading=  false
        })

    }

    // 合作伙伴列表取消
    handleParnterDialog(){
        if(!this.parnterConfirmList || (this.parnterConfirmList.marketCooperationId != this.parnterDialogSelect.marketCooperationId)){
            const parnterTable = this.$refs.parnterDialogTable as HTMLFormElement
            parnterTable.clearSelection()
            parnterTable.toggleRowSelection(this.parnterConfirmList,true)
        }
        if(this.parnterDialogSelect){
            const parnterTable = this.$refs.parnterDialogTable as HTMLFormElement
            parnterTable.toggleRowSelection(this.parnterDialogSelect,true)
        }
        this.parnterDialog = false
    }
    chooseParnter(e) {
        this.customerNameOrMarketCooperationName = ''
        this.parnterDialogInputValue = ''
        this.parnterDialogPage = 1
        this.parnterDialog = true
        this.getCustomerNameListByFinanceBackMoneyMainPart()
        e.target.blur()
    }

    parnterDialogConfirm() {
        this.parnterConfirmList = this.parnterDialogSelect  //存数据取消选中状态
        this.formData.parnterName = this.parnterDialogSelect.marketCooperationName
        this.parnterDialog = false
        this.parnterDialogInputValue = ''
        this.tableData = []
    }

    parnterDialogSelectionChange(selectionArr) {

        if(selectionArr.length > 0) {
            this.parnterDialogSelect = JSON.parse(JSON.stringify(selectionArr[0]))
            if(selectionArr.length > 1) {
                const parnterTable = this.$refs.parnterDialogTable as HTMLFormElement
                parnterTable.clearSelection()
                parnterTable.toggleRowSelection(selectionArr.pop())
            }
        } else {
            for(const key in this.parnterDialogSelect) {
                this.parnterDialogSelect[key] = null
            }
        }
    }

    parnterDialogPageChange(page: number) {
        this.parnterDialogPage = page
        this.getCustomerNameListByFinanceBackMoneyMainPart()
    }
    pageSizeChange(limit: number) {
        this.limit = limit
        this.getCustomerNameListByFinanceBackMoneyMainPart()
    }

    clickAddOrder() {
        if(!this.formData.parnterName) {
            this.$message.error('请选择机构')
            return
        }
        this.orderDialogPage = 1
        this.orderDialogInputValue = ''
        this.orderDialog =  true
        this.getFinanceOrderByCustomerIdOrMarketCooperationId()
        this.defaultChecked()
    }
    // 新增一键设置价格
    clickSetPrice(){
        if(this.tableData.length == 0){
            this.$message.error('请添加订单')
            return
        }
        this.setPrice = ''
        this.setPriceDialogShow = true
    }
    handleSetPriceDialogSave(){
        if(this.setPrice == '' || this.setPrice == undefined || this.setPrice == null){
            this.$message.error('请填写本次回款金额')
            return
        }
        this.tableData = this.tableData.map(item => ({ ...item,thisBackMoney: this.setPrice,newNeedBackMoney: math.number(math.subtract(math.bignumber(Number(item.needBackMoney)) , math.bignumber(Number(this.setPrice)))) }))
        this.setPriceDialogShow = false
    }
    // 下载导入回款模板
    async clickDownload(){
        const data: any = await getFinanceBackMoneyDetailTemplate()
        const a: any = document.createElement('a')
        a.href = data.financeBackMoneyDetailTemplateUrl //  URL对象
        a.click() // 模拟点击
    }

    // 导入
    handleFileChange(file,fileList) {
        const upload: any = this.$refs.upload
        upload.clearFiles()
        this.file = fileList.slice(-1);
        if(this.file.length > 0){
            this.sureExport()
        }

    }
    handleFile(){
        if(this.formData.parnterName){
            this.readyOption = false
        }else {
            this.$message.error('请选择机构')
            return
        }
    }
    async sureExport() {
        this.loading = true
        const formData = new FormData()
        formData.append('file', this.file[0].raw)
        importFinanceBackMoneyDetail(formData).then((res) => {
            const { financeOrderList } = res as unknown as { financeOrderList: any }

            if (financeOrderList.length > 0) {
                const val = financeOrderList[0].companyName
                const flag = financeOrderList.every(ele => ele.companyName === val)
                if (!flag) {
                    this.$message.error('所选订单的收款账户不一致')
                }
                this.formData.backMoneyAccount = val
            }

            financeOrderList.map(item => {
                /*判读tableData里是否已存在，不存在则添加*/
                const Index = this.tableData.findIndex((items) => {
                    return items.id === item.id
                })
                if (Index == -1) {
                    this.tableData.push({
                        ...item,
                        thisBackMoney: item.thisTimePrice ? item.thisTimePrice : 0,
                        // newNeedBackMoney: item.needBackMoney ? item.needBackMoney : 0 ,  //待回款金额
                        newNeedBackMoney: item.thisTimePrice ? math.number(math.subtract(math.bignumber(Number(item.needBackMoney)), math.bignumber(Number(item.thisTimePrice)))) : 0,  //待回款金额
                    })
                }
            })
            this.loading = false
            this.file = []
            this.fileData = {}
        }).catch(err => {
            console.log(err)
            this.loading = false
        })
    }


    // 订单列表取消
    handleOrderDialog(){
        this.orderDialogSelectTable.map(item => {
            this.tableData.map(items => {
                if(item.id !== items.id){
                    const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
                    orderDialogTable.clearSelection()
                }
            })
        })

        if(this.tableData.length > 0){
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            this.tableData.forEach(row => {
                orderDialogTable.toggleRowSelection(row,true)
            });
        }else {
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            orderDialogTable.clearSelection()
        }
        this.orderDialog = false
    }
    orderDialogConfirm() {
        this.tableData = []
        this.orderDialogSelectTable.map(item => {
            const Index = this.tableData.findIndex((items) => {return items.id === item.id})
            if(Index == -1){
                this.tableData.push({
                    ...item,
                    thisBackMoney: item.thisBackMoney ? item.thisBackMoney : 0,
                    // newNeedBackMoney: item.needBackMoney,  //新建时候待回款金额
                    newNeedBackMoney: !item.thisBackMoney ? item.needBackMoney :(item.thisBackMoney==0?item.needBackMoney: (math.number(math.subtract(math.bignumber(  item.needBackMoney) ,math.bignumber( Number(item.thisBackMoney)))))),
                    oldThisBackMoney: 0, // 新建的时候默认 oldThisBackMoney = 0，当编辑审批通过的回款的时候，需要用来记录编前的当前回款
                    thisBackMoneyWay: item.thisBackMoneyWay ? item.thisBackMoneyWay : '',
                })
            }
        })
        this.orderDialog = false
        this.orderDialogInputValue = ''
        this.formData.backMoneyAccount = this.tableData[0].companyName
    }

    clickOrderDialogFilter(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.orderDialogPage = page
            this.getFinanceOrderByCustomerIdOrMarketCooperationId()
        }, 1000)
    }



    // async clickOrderDialogFilter() {
    //     this.orderDialogPage = 1;
    //     // (this.$refs.orderDialogTable as HTMLFormElement).clearSelection()
    //     // this.getFinanceOrderByCustomerIdOrMarketCooperationId()
    //     this.orderDialogTableLoading = true
    //     const obj = {
    //         mainPart: '1',
    //         page: this.orderDialogPage,
    //         marketCooperationId: this.parnterDialogSelect.marketCooperationId,
    //         limit: this.orderDialogTotal
    //     }
    //     for (const key in obj) {
    //         if (obj[key] == '' || !obj[key]) {
    //             delete obj[key]
    //         }
    //     }
    //     const data: any = await getFinanceOrderByCustomerIdOrMarketCooperationId(obj)
    //     this.orderDialogTaleData = data.financeOrderList.filter(item => item.customerName.includes(this.orderDialogInputValue))
    //     this.orderDialogFilterTotal = this.orderDialogTaleData.length
    //     this.orderDialogTableLoading = false
    // }
    orderDialogSelectionChange(selectionArr: any[]) {
        if (selectionArr.length > 0) {
            const val = selectionArr[0].companyName
            const flag = selectionArr.every(ele => ele.companyName === val)
            if (!flag) {
                this.$message.error('所选订单的收款账户不一致')
            }
        }
        this.orderDialogSelectTable = selectionArr
        if(this.tableData.length > 0){
            this.tableData.map(item => {
                this.orderDialogSelectTable.map(items => {
                    if(item.id == items.id) {
                        items.thisBackMoney = item.thisBackMoney
                        items.thisBackMoneyWay = item.thisBackMoneyWay
                    }
                })
            })
        }
    }

    orderDialogPageChange(page: number) {
        this.orderDialogPage = page
    }
    handleBackMoneyOnInput(num,limit){
        const len1 = num.charAt(0)
        // 转化为数字形式--包含小数，负数
        // 先把非数字的都替换掉，除了数字和.
        num = num.replace(/[^\d.]/g, '')
        // 必须保证第一个为数字而不是.
        num = num.replace(/^\./g, '')
        // 保证只有出现一个.而没有多个.
        num = num.replace(/\.{2,}/g, '.')
        // 保证.只出现一次，而不能出现两次以上
        num = num.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
        // 如果第一位是负号，则允许添加
        if (len1 === '-') {
            num = '-' + num
        }
        return num
    }
    thisBackMoneyChange(row, val){
        val = this.handleBackMoneyOnInput(val,'2')
        row.thisBackMoney = this.handleBackMoneyOnInput(val,'2')
        // if(Number(row.thisBackMoney) > Number(row.needBackMoney) + Number(row.oldThisBackMoney)) {
        //     row.priceChecking = false
        //     if(document.getElementsByClassName('el-message').length > 0) return
        //     this.$message.error('本次回款金额不得大于待回款金额')
        //     return
        // }
        this.tableData.forEach(item => {
            if(item.id === row.id){
                if(val == ''){
                    val = 0
                }
                item.newNeedBackMoney = math.number(math.subtract(math.bignumber(Number(item.needBackMoney)), math.bignumber(Number(val))))
            }
            // if(item.id === row.id) row.newNeedBackMoney = Number(item.needBackMoney) - Number(val)
        })
        // this.orderDialogSelectTable.map(item => {
        //     if(row.id == item.id)
        //     item.thisBackMoney = Number(val)
        // })
        row.priceChecking = true
    }

    clickDelOrder(row) {
        const order = this.$refs.orderDialogTable as HTMLFormElement
        this.tableData = this.tableData.filter(item => item.id !== row.id)
        this.orderDialogSelectTable = this.orderDialogSelectTable.filter(item => item.id !== row.id)
        this.tableData.forEach(row => {
            order.toggleRowSelection(row, true)
        })
    }

    async clickParnterDialogFilter() {
        if (this.timernew !== null) clearTimeout(this.timernew)
        this.timernew = setTimeout(() => {
            this.parnterDialogPage = 1
            this.customerNameOrMarketCooperationName = this.parnterDialogInputValue
            this.getCustomerNameListByFinanceBackMoneyMainPart()
            // this.parnterDialogTableLoading = true
            // const data: any = await getCustomerNameListByFinanceBackMoneyMainPart({ mainPart: '1', page: this.parnterDialogPage, limit: this.parnterDialogTotal })
            // this.parnterDialogTaleData = data.customerList.filter(item => item.marketCooperationName.includes(this.parnterDialogInputValue))
            // this.parnterDialogFilterTotal = this.parnterDialogTaleData.length
            // this.parnterDialogTableLoading = false
        }, 1000)
    }

    setDraftById(isSubmit: string) {
        let flag = true
        if (!this.formData.payMethod) {
            this.$message.error('请选择付款方式');
            return;
        }
        /*必填项校验*/
        (this.$refs.formRef as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false
                return
            }
        })
        const obj = {
            mainPart: '0',
            marketCooperationId: this.parnterDialogSelect.marketCooperationId,
            account: this.formData.backMoneyAccount,
            backMoneyAt: formatDate('yyyy-MM-dd', new Date(this.formData.date)),
            financeBackMoneyDetailList: [],
            financeBackMoneyProofList: this.fileList,
            directorUserId: this.formData.directorUserId,
            remark: this.formData.remark,
            payMethod: this.formData.payMethod,
            content:( this.tableData.some(item => Number(item.thisBackMoney) < (Number(item.needBackMoney)))  && isSubmit == '1') ? this.needBackMoneyReason : ''
        }

        // this.tableData.forEach(item=>{
        //     if(!item.thisBackMoney){
        //         flag = false
        //         this.$message.error('未填写回款金额，请填写后提交')
        //     }
        // })


        obj.financeBackMoneyDetailList = this.tableData.map(item => {
                return ({
                    financeOrderId: item.id,
                    thisTimePrice: String(item.thisBackMoney),
                    types: String(item.thisBackMoneyWay)
                })
            }
        );
        /*
       * 判断数组的每一项是否都不为0*/
        const isAllZero = obj.financeBackMoneyDetailList.every(item => (item.thisTimePrice !== 0 && item.thisTimePrice !== ''));
        if (!isAllZero) {
            this.$message.error('有未填写本次回款金额的订单，请去填写')
            return;
        }
        /*判断this.tableData的每一项的thisBackMoneyWay都不为空*/
        if (!(obj.financeBackMoneyDetailList.every(item => (item.types !== '' && item.types !== 'undefined')))) {
            this.$message.error('有未填写本次回款方式的订单，请去填写')
            return
        }

        if (!this.needBackMoneyReason && isSubmit == '1') {
            /*判断每一个订单的本次回款金额是否等于待回款金额*/
            if (this.tableData.some(item => Number(item.thisBackMoney) < (Number(item.needBackMoney)))) {
                this.reasonDialogVisible = true
                flag = false
            }
        }
        if (flag) {
            this.disabledButton = true
        } else {
            return;
        }
        this.loading = true
        setDraftById({
            id: this.draftId,
            form: obj,
            isSubmit
        }).then(res => {
            this.$message.success(`${isSubmit === '0' ? '保存成功，页面即将关闭' : '提交成功，页面即将关闭'}`)
            this.loading = false
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            if (err.message == '审批流报错') {
                this.errorDialogShow = true
            }
            this.disabledButton = false
            this.loading=  false
        })
    }

    orderDialogTableSelect(row) {
        // return row.needBackMoney !== 0 // 2023-6-20  去掉待回款金额为零不可选择的限制
    }

    // 点击行选中表格 2021.9.27
    clickParnterDialogTableRow(row) {
        (this.$refs.parnterDialogTable as HTMLFormElement).toggleRowSelection(row)
    }
    defaultChecked(){
        this.$nextTick(() => {
            const order = (this.$refs.orderDialogTable as HTMLFormElement)
            order.clearSelection();
            this.tableData.forEach(row => {
                order.toggleRowSelection(row, true)
            })
        })
    }

    clickOrderDialogTableRow(row) {
        // if(row.needBackMoney == 0){ //禁用
        //     row.selectDisabled = false
        // }else if(row.needBackMoney != 0){
        //     row.selectDisabled = true
        // }
        // if(!(row.selectDisabled && row.needBackMoney !== 0)) return
        /*
        * 移除待回款金额为零时不可选的限制*/
        (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
        // let a = (this.$refs.orderDialogTable as HTMLFormElement).selection
        // if(a.length == 0){
        //     this.oldRowOrderDialogSelectTable.push(row.id)
        // }else if(a.length > 0){
        //     const Index = a.findIndex((items) => {return items.id === row.id})
        //     if(Index == -1){
        //         this.oldRowOrderDialogSelectTable.push(row.id)
        //     }
        // }
    }


    uploadSuccess(response, file, fileList) {
        const data = response.data
        if (fileList.every(item => item.status == 'success')) {
            this.fileList = fileList.map(item => {
                if (item.status == 'success') {
                    return {
                        name: item.name,
                        url: item.url ? item.url : item.response.data.ossUrl
                    }
                }
            });
            this.$message.success('上传成功')
            // 手动触发 Vue 更新
            this.$forceUpdate();
        }
    }
    uploadError() {
        this.$message.error('上传失败')
    }
    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }
    handlePreview(file) {
        this.previewPath = file.url
        this.previewName = file.name
        this.previewVisible = true
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }
    clickSavaDraftButton() {
        this.isDraft = '1'
        this.saveDraftDialogShow = true
    }
    saveDraftDialogConfirm() {
        this.clickSubmintButton()
    }
    saveDraftDialogCancel() {
        this.isDraft = '0'
        this.saveDraftDialogShow = false
    }

    closePage() {
        window.close()
    }

    handleNeedBackMoneyReasonSave() {
        if (this.needBackMoneyReason) {
            if (!this.backMoneyId  && !this.draftId || this.orderId) {
                this.clickSubmintButton()
            } else if (this.backMoneyId ) {
                this.clickEditSubmitButton()
            } else if (this.draftId) {
                this.setDraftById('1')
            }
            this.reasonDialogVisible = false
        }
    }

    changeDirectorUserId(e){
        this.formData.directorUserId = e.id
        if (e.id) {
            this.formData.deparment = e.departmentName
        }
    }

    @Watch("directorUserId", { deep: true })
    handle(userId: string) {
        if(!this.formData.directorUserId){
            this.formData.directorUserId = userId
        }
    }

    @Watch("userName", {deep: true})
    handledirectorUserName(userName: string) {
        if (!this.directorUserName) {
            this.directorUserName = userName
        }
    }



    @Watch('departmentName')
    handleChangeDepartmentName(val) {
        if (!this.formData.deparment) {
            this.formData.deparment = val
        }
    }

}
